var app = {
	header: {
		build: "빌드",
		closeButton: "닫기",
		copyrightLabel: "저작권",
		helpLabel: "도움말",
		legalNoticeLabel: "법적 고지",
		logoutButton: "로그아웃",
		menuLabel: "메뉴",
		module: "모듈",
		myData: "내 데이터",
		noUserDataLabel: "사용자 데이터 없음",
		notificationsLabel: "알림",
		privacyPolicyLabel: "개인정보 처리방침",
		search: "검색",
		searchPlaceholder: "검색할 용어 또는 질문",
		serviceAppLabel: "서비스 앱",
		settingsLabel: "설정",
		shopLabel: "상점",
		smartFactorySuiteLabel: "스마트 팩토리 스위트",
		softwareInformation: "소프트웨어 정보",
		toMytrumpf: "MyTRUMPF로",
		toTrumpfCom: "trumpf.com으로",
		userLabel: "프로필",
		userProfileLinkText: "사용자 프로필",
		version: "버전"
	}
};
var contentLoadingError = "콘텐츠를 로드할 수 없습니다";
var dashboard = {
	cancel: {
		button: "취소"
	},
	edit: {
		button: "편집"
	},
	reset: {
		button: "재설정"
	},
	save: {
		button: "저장"
	},
	share: {
		button: "공유"
	}
};
var fileUpload = {
	invalidFileType: "파일 유형이 잘못되었습니다",
	maxFileSize: "파일이 허용된 크기보다 큽니다 (최대 {{maxSizeInMb}} MB)",
	maxFilesReached: "최대 파일 수에 도달했습니다"
};
var filter = {
	clear: "필터 재설정",
	clearAll: "모든 필터 재설정"
};
var general = {
	nextButton: "다음",
	prevButton: "이전",
	resetButton: "재설정"
};
var locationMap = {
	locationLink: {
		label: "위치로 이동"
	}
};
var machineDiscontinuation = {
	linkText: "자세히 알아보기"
};
var notifications = {
	button: {
		loadMore: "더 보기"
	},
	date: {
		lastMonth: "지난 달",
		lastWeek: "지난 주",
		older: "이전",
		thisMonth: "이번 달",
		thisWeek: "이번 주",
		today: "오늘",
		yesterday: "어제"
	},
	error: {
		general: "현재 알림을 표시할 수 없습니다. 나중에 다시 시도하십시오.",
		unauthorized: "알림을 보려면 로그인하십시오."
	},
	info: {
		activateSettings: "알림을 받으려면 설정에서 활성화하십시오.",
		noNotification: "현재 메시지가 없습니다."
	},
	title: "알림"
};
var results = {
	counter: {
		label: "건의 결과"
	}
};
var scrollToTop = {
	label: "맨 위로 스크롤"
};
var slider = {
	nextButton: {
		label: "다음 슬라이드"
	},
	paginationBullet: {
		label: "슬라이드"
	},
	prevButton: {
		label: "이전 슬라이드"
	}
};
var sorting = {
	ascending: "오름차순",
	descending: "내림차순"
};
var userAccount = {
	address: {
		label: "우편 주소"
	},
	email: {
		label: "이메일"
	},
	language: {
		label: "언어",
		locale: "로케일",
		select: "언어 선택",
		settings: "언어 설정"
	},
	loggedOut: {
		message: "로그인하지 않았습니다."
	},
	login: {
		button: "로그인"
	},
	name: {
		label: "이름"
	},
	phone: {
		label: "전화"
	}
};
var widget = {
	filter: {
		machine: {
			filter: "기계 필터링",
			label: "기계",
			option: {
				all: "모든 기계"
			},
			select: "기계 선택"
		},
		period: {
			label: "기간",
			option: {
				currentMonth: "이번 달",
				currentWeek: "이번 주",
				lastMonth: "지난 달",
				lastWeek: "지난 주",
				today: "오늘",
				yesterday: "어제"
			}
		}
	}
};
var widgetRegistry = {
	allWidgets: {
		label: "내 위젯"
	},
	noDescriptionAvailable: "설명이 없습니다.",
	widget: {
		SampleMyMachines: {
			title: "내 기계"
		},
		SampleMyServiceCalls: {
			title: "서비스 호출"
		},
		SampleMyTrackingList: {
			title: "추적 목록"
		},
		SampleMyUserAccount: {
			title: "내 프로필"
		},
		SampleOperationalStatesChart: {
			title: "운영 상태"
		},
		SampleWidgetFilter: {
			title: "필터 설정"
		},
		SampleWorkloadBalanceChart: {
			title: "작업 부하 균형"
		}
	}
};
var translation = {
	app: app,
	contentLoadingError: contentLoadingError,
	dashboard: dashboard,
	fileUpload: fileUpload,
	filter: filter,
	general: general,
	locationMap: locationMap,
	machineDiscontinuation: machineDiscontinuation,
	notifications: notifications,
	results: results,
	scrollToTop: scrollToTop,
	slider: slider,
	sorting: sorting,
	userAccount: userAccount,
	widget: widget,
	widgetRegistry: widgetRegistry
};

export { app, contentLoadingError, dashboard, translation as default, fileUpload, filter, general, locationMap, machineDiscontinuation, notifications, results, scrollToTop, slider, sorting, userAccount, widget, widgetRegistry };
